@if (showLoader) {
	<div class="w-full h-screen bg-[#0BC582]">
		<app-loader></app-loader>
	</div>
} @else {
	<ng-container *ngIf="!(toggleHeader$ | async)">
	<app-navigation class="sticky top-0 z-[80]"></app-navigation>
	</ng-container>
	<main (scroll)="onScroll()" class="app-portal-shell z-2"></main>
	<app-footer ></app-footer>
	<!-- <ng-progress></ng-progress> -->
	<lib-toaster-container></lib-toaster-container>
	<lib-banner-modal></lib-banner-modal>
}